import React, { FC } from 'react'
import { FormattedDateTimeRange } from 'transfix-ui/components/FormattedDateTimeRange'
import { makeStyles, Typography } from 'transfix-ui/core'
import { ITrailerShipmentFragment } from 'apps/marketplace/pages/shippers/components/ShipperTrailers/graphql/TrailerShipmentFragment'
import { currentTimezone } from 'constants/AllowedTimezones'
import { DISPLAY } from 'constants/display'
import EmptyInfo from './EmptyInfo'

interface INextAppointmentProps {
  currentStop: ITrailerShipmentFragment['stops'][number] | undefined
  nextStop: ITrailerShipmentFragment['stops'][number] | undefined
  currentStopName: string
}

const useStyles = makeStyles(theme => ({
  stopType: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },
    [theme.breakpoints.up('xl')]: {
      display: 'none',
    },
  },
}))

const NextAppointment: FC<INextAppointmentProps> = ({ currentStop, currentStopName, nextStop }) => {
  const styles = useStyles()

  const { appointment: currentStopAppt } = currentStop || {}
  const { appointment: nextStopAppt } = nextStop || {}

  if (nextStop || currentStop) {
    return (
      <div>
        <Typography variant='body1'>
          {currentStop && (
            <span className={styles.stopType}>
              {currentStopName} {DISPLAY.empty}{' '}
            </span>
          )}
          <FormattedDateTimeRange
            startAt={(nextStopAppt?.startAt || currentStopAppt?.startAt) ?? ''}
            endAt={(nextStopAppt?.endAt || currentStopAppt?.endAt) ?? ''}
            startAtTimezone={nextStopAppt?.timezone || currentStopAppt?.timezone || currentTimezone}
            endAtTimezone={nextStopAppt?.timezone || currentStopAppt?.timezone || currentTimezone}
            format='time'
          />
        </Typography>
      </div>
    )
  }

  return <EmptyInfo />
}

export default NextAppointment
